import React from "react";
import "../../App.css";
import "../../assets/style/LessonTypes.css";
import { weekDayMap } from "../../consts";
import { getLessonTypeStyle } from "../../utils/colorUtils";
import { useAuthStore } from "../../store";
import BatteryIndicator from "./BatteryIndicator";

const SingleHour = ({
  hour,
  handleOpenSignUpModal,
  setValues,
  values,
  setLessonData,
}) => {
  const { isAdmin } = useAuthStore((state) => ({
    isAdmin: state.isAdmin,
  }));

  const timeSlots = [];
  const startDay = 0;
  const endDay = 7;

  const addLeadingZeros = (num) => String(num).padStart(2, "0");

  const isLessonInPast = (lesson) => {
    const currentTime = new Date();
    const lessonStartTime = new Date(
      lesson.start.year,
      lesson.start.month - 1,
      lesson.start.day,
      lesson.start.hour,
      lesson.start.minute,
      0
    );
    return lessonStartTime <= currentTime;
  };

  for (let i = startDay; i < endDay; i++) {
    if (!hour) {
      timeSlots.push(<td key={`empty-${i}`} className="bg-light-gray" />);
      continue;
    }

    const lessonsInSameHour = hour.filter(
      (lesson) => weekDayMap[i] === lesson.week_day
    );

    if (lessonsInSameHour.length > 0) {
      const lessonGroup = lessonsInSameHour.map((lesson) => {
        const start = `${addLeadingZeros(lesson.start.hour)}:${addLeadingZeros(
          lesson.start.minute
        )}`;
        const end = `${addLeadingZeros(lesson.end.hour)}:${addLeadingZeros(
          lesson.end.minute
        )}`;

        // Safety check: ensure current_people and max_people are valid numbers
        const currentPeople = Number(lesson.current_people) || 0;
        const maxPeople = Number(lesson.lesson_type.max_people) || 999;
        const isFull = currentPeople >= maxPeople;
        const isPast = !isAdmin && isLessonInPast(lesson);

        return (
          <div key={lesson.lesson_id} className="lesson-block">
            <span
              className={`lesson-type-block padding-5px-tb padding-15px-lr border-radius-5 margin-10px-bottom text-white font-size16 xs-font-size13 ${
                isPast
                  ? "past-lesson"
                  : isFull
                  ? "full-lesson"
                  : "clickable"
              }`}
              style={getLessonTypeStyle(lesson.lesson_type.bg_color)}
              data-testid={`lesson-${lesson.lesson_id}`}
              onClick={() => {
                if (!isPast) {
                  handleOpenSignUpModal(lesson);
                }
              }}
            >
              {lesson.lesson_type.friendly_name}
              {lesson.payment_only_online && !lesson.lesson_type.is_free && (
                <span className="online-only-indicator" title="Płatność tylko online">
                  💳
                </span>
              )}
            </span>
            <div className="margin-10px-top font-size14">
              {start} - {end}
            </div>
            <div
              data-testid={`lesson-${lesson.lesson_id}-slots`}
              className="font-size13"
            >
              {isAdmin ? (
                `${currentPeople}/${maxPeople}`
              ) : (
                <BatteryIndicator
                  currentPeople={currentPeople}
                  maxPeople={maxPeople}
                />
              )}
              {lesson.waitlist_count > 0 && (
                <div className="waitlist-indicator font-size12" title="Lista oczekujących">
                  ⏳ {lesson.waitlist_count}
                </div>
              )}
            </div>
            {isPast && (
              <div className="past-lesson-text">
                Zajęcia się odbyły
              </div>
            )}
          </div>
        );
      });

      timeSlots.push(
        <td key={`lesson-group-${i}`} className="lesson-group-cell" rowSpan={1}>
          {lessonGroup}
        </td>
      );
    } else {
      timeSlots.push(<td key={`empty-${i}`} className="bg-light-gray" />);
    }
  }

  return <tr>{timeSlots}</tr>;
};

export default SingleHour;
